module.exports = __webpack_public_path__ + "static/media/icon-improve.dd981ae1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/icon-improve.svg
// module id = 1257
// module chunks = 0